<div class="step-container">
  <h2 class="step-title">Comprobantes de servicios</h2>
  <p class="step-subtitle">
    Suba 1 o 2 comprobantes de servicios a su nombre (luz, gas, agua, etc.).
    Formatos aceptados: PDF, JPG, PNG. Tamaño máximo: 10MB por archivo.
  </p>

  <!-- File list -->
  <div *ngIf="files.length > 0" class="file-list">
    <div *ngFor="let file of files; let i = index" class="file-item">
      <div class="file-info">
        <mat-icon class="file-icon">description</mat-icon>
        <div class="file-details">
          <span class="file-name">{{ file.name }}</span>
          <span class="file-size">{{ formatFileSize(file.size) }}</span>
        </div>
      </div>
      <button mat-icon-button (click)="removeFile(i)" [disabled]="loading">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Upload button -->
  <div *ngIf="files.length < 2" class="upload-area">
    <button mat-stroked-button class="upload-button" (click)="fileInput.click()" [disabled]="loading">
      <mat-icon>cloud_upload</mat-icon>
      Seleccionar archivo
    </button>
    <input
      #fileInput
      type="file"
      accept=".pdf,.jpg,.jpeg,.png,.webp"
      hidden
      (change)="onFileSelected($event)" />
  </div>

  <div *ngIf="errorMessage" class="error-message">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <button
    mat-raised-button
    color="primary"
    class="action-button"
    [disabled]="loading || files.length === 0"
    (click)="onSubmit()">
    <mat-spinner *ngIf="loading" diameter="24" class="button-spinner"></mat-spinner>
    <span *ngIf="!loading">Enviar comprobantes</span>
  </button>
</div>
